
import Vue from "vue";
import dialogCom from "@/components/ModelCom.vue";
import CookieUtil from "@/assets/js/CookieUtil";
import { cookieTypes } from "@/assets/js/Types";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
export default Vue.extend({
  props: ["title"],
  components: { dialogCom },
  data() {
    return {
      projectForm: {
        startTime: new Date(),
        endTime: new Date(),
        enable: 0,
      },
    };
  },
  mounted() {
    //
  },
  methods: {
    open() {
      const dialog: any = this.$refs.fileDialog;
      dialog.show();
    },
    hiden() {
      const dialog: any = this.$refs.fileDialog;
      dialog.hiden();
    },
    async exportData() {
      const ret = {
        enable: this.projectForm.enable == 0 ? false : true,
        startTime: Utils.FormatData(this.projectForm.startTime),
        endTime: Utils.FormatData(this.projectForm.endTime),
      };
      this.$emit("chargePolicy", ret);
    },
  },
});
